module.exports = __webpack_public_path__ + "static/media/vtex-manual-import1.8544f8f0.png";